import { createContext, useContext, useState } from "react";

export const PagSeguroContext = createContext();

export const PagSeguroProvider = ({ children }) => {
  const [sessionID, setSessionID] = useState("");
  const [creditCardNumber, setCreditCardNumber] = useState("");
  const [creditCardExpirationMonth, setCreditCardExpirationMonth] =
    useState("");
  const [creditCardExpirationYear, setCreditCardExpirationYear] = useState("");
  const [creditCardCVV, setCreditCardCVV] = useState("");
  const [creditCardBrand, setCreditCardBrand] = useState("");
  const [installmentsArr, setInstallmentsArr] = useState([]);
  const [isLoadingInstallments, setIsLoadingInstallments] = useState(false);
  const [pagSeguroDirectPaymentInstance, setPagSeguroDirectPaymentInstance] =
    useState(null);
  const [pgReady, setPgReady] = useState(false);

  const pagseguro = {
    sessionID,
    creditCardNumber,
    creditCardExpirationMonth,
    creditCardExpirationYear,
    creditCardCVV,
    creditCardBrand,
    installmentsArr,
    isLoadingInstallments,
  };

  return (
    <PagSeguroContext.Provider
      value={{
        sessionID,
        setSessionID,
        creditCardNumber,
        setCreditCardNumber,
        creditCardExpirationMonth,
        setCreditCardExpirationMonth,
        creditCardExpirationYear,
        setCreditCardExpirationYear,
        creditCardCVV,
        setCreditCardCVV,
        creditCardBrand,
        setCreditCardBrand,
        installmentsArr,
        setInstallmentsArr,
        isLoadingInstallments,
        setIsLoadingInstallments,
        pagseguro,
        pagSeguroDirectPaymentInstance,
        setPagSeguroDirectPaymentInstance,
        pgReady,
        setPgReady,
      }}
    >
      {children}
    </PagSeguroContext.Provider>
  );
};

export const usePagSeguroContext = () => {
  return useContext(PagSeguroContext);
}
